import api from "api/axios";

// Télécharge un fichier généré par l'API (Excel, PDF...) sous le nom indiqué
export async function telechargerFichier(url, nomParDefaut) {
  const res = await api.get(url, { responseType: "blob" });
  // Nom envoyé par le serveur (Content-Disposition), sinon nom par défaut
  const dispo = res.headers?.["content-disposition"] || "";
  const m = dispo.match(/filename="?([^";]+)"?/);
  const lien = window.URL.createObjectURL(new Blob([res.data], { type: res.headers?.["content-type"] }));
  const a = document.createElement("a");
  a.href = lien;
  a.download = m ? m[1] : nomParDefaut;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(lien);
}
